// Constants
export const SKELETON_COUNT = 6
export const ITEMS_PER_PAGE = 16
